// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"1dea5112","133":"f4cf72bf","195":"e2f94131","453":"abd36b29","548":"8450b96a","550":"60acf51a","553":"4c39402c","909":"7627fec3"}[chunkId] + ".chunk.js";
};